import { useEffect } from 'react';
import Modal from 'react-modal';
import { useForm } from 'react-hook-form';
import { useAppDispatch } from '../redux/store';
import { postLoungeFlag, postLoungeFlagWdw } from '../redux/lounges/slice';

type CommentReportModalProps = {
  isOpen: boolean;
  onClose: () => void;
  /** chat_reply_id for a comment ('R'), reply id for a reply ('CR'). */
  itemId: any;
  type: 'R' | 'CR';
  park: 'DL' | 'WDW';
};

type FormData = {
  ReasonForReport: string;
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    width: '100%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    background: '#F5F5F5',
    transform: 'translate(-50%, -50%)',
  },
};

export const CommentReportModal: React.FC<CommentReportModalProps> = ({
  isOpen,
  onClose,
  itemId,
  type,
  park,
}) => {
  const dispatch = useAppDispatch();
  const { register, handleSubmit, reset } = useForm<FormData>();

  useEffect(() => {
    if (!isOpen) reset();
  }, [isOpen, reset]);

  const onSubmit = ({ ReasonForReport }: FormData) => {
    // Each park has its own flag endpoint; sending a WDW id to the Disneyland
    // endpoint would report (and hide) an unrelated Disneyland item.
    const flag = park === 'WDW' ? postLoungeFlagWdw : postLoungeFlag;
    dispatch<any>(
      flag({ LoungeId: itemId, Type: type, ReasonForReport } as any)
    ).then((res: any) => {
      const message = res?.payload?.data?.[0]?.error;
      onClose();
      if (message) window.alert(message);
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel={type === 'CR' ? 'Report reply' : 'Report comment'}
    >
      <form className='space-y-6' onSubmit={handleSubmit(onSubmit)} method='POST'>
        <div className='row'>
          <div className='box-t-1'>
            <h6 style={{ fontWeight: 400, color: 'red' }}>Report</h6>
            <div
              className='close-p'
              role='button'
              aria-label='Close report'
              onClick={onClose}
            >
              <i className='fa fa-close my-b' />
            </div>
            <div className='boxwidth'>
              <div className='box-ttt'>
                <textarea
                  rows={3}
                  cols={60}
                  placeholder='write reason for reporting'
                  {...register('ReasonForReport')}
                />
                <div className='mw-post text-center'>
                  <input className='MW-btn' type='submit' value='Post' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};
